// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__zwe4J","question":"Question_question__2Wh4r","description":"Question_description__13o6T"};